import { render, staticRenderFns } from "./gasConsumeUinit.vue?vue&type=template&id=dc95d9be&scoped=true"
import script from "./gasConsumeUinit.vue?vue&type=script&lang=js"
export * from "./gasConsumeUinit.vue?vue&type=script&lang=js"
import style0 from "./gasConsumeUinit.vue?vue&type=style&index=0&id=dc95d9be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc95d9be",
  null
  
)

export default component.exports